import { productTypes } from '@shared/heplers/const-data';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class EnumProductGuardService  {
  private router = inject(Router);


  productTypes = [productTypes.EVENTO, productTypes.SUBSCRIPTION];

  public canActivate(
    next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const objectType: string = next.paramMap.get('productType')!;
    const objectTypeFound = this.productTypes.find(key => key === objectType);

    if (!objectTypeFound) {
      this.router.navigate(['/'])
      return false;
    }
    return true;
  }

}
